import { Consultation, ConsultationType } from '../@types'

export const getConsultationStartTime = (consultation: Consultation) => {
  return consultation.type === ConsultationType.SCHEDULED ? consultation.startTime : consultation.createdAt
}
